import React, { useState } from 'react';
import { Stepper, Step, StepLabel } from '@mui/material';
import { steps, stepFields } from './fields'; // Import from fields.js
import FormTemplate from './FormTemplate'; // Import the form template component
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../../../../Constants';

const InvoiceFormWizard = ({ initialFormData = {} }) => {
  const [activeStep, setActiveStep] = useState(0);

  // Initialize formData with default values to avoid undefined errors
  const [formData, setFormData] = useState({
    invoiceNumber: '',
    invoiceDate: '',
    customer: '',
    buildingID: '',
    addressOne: '',
    addressTwo: '',
    city: '',
    state: '',
    zip: '',
    invoiceAmount: '',
    partsAmount: '',
    discountAmount: '',
    taxAmount: '',
    isOpen: true, // Set default checkbox value to true
    ...initialFormData, // Merge with any initial data provided
  });

  const navigate = useNavigate();

  const handleNext = () => setActiveStep((prevStep) => prevStep + 1);
  const handleBack = () => setActiveStep((prevStep) => prevStep - 1);

  const handleChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  const handleFinish = async () => {
    try {
      console.log('Submitting Form Data:', formData);
      const response = await fetch(API_BASE_URL + '/api/invoice/invoice-entry-page', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        alert('Invoice created successfully');
        navigate('/dashboard'); // Navigate to dashboard after successful submission
      } else {
        throw new Error('Failed to create invoice');
      }
    } catch (error) {
      console.error('Error during form submission:', error);
      alert('An error occurred while submitting the invoice');
    }
  };

  const handleCancel = () => {
    navigate('/dashboard'); // Navigate to dashboard on cancel
  };

  return (
    <div className="flex flex-col lg:flex-row items-start p-5 lg:p-10 gap-6 max-w-5xl mx-auto">
      <div className="w-full lg:w-3/4 p-6 bg-white rounded-lg border border-gray-300 shadow-xl flex flex-col">
        <h2 className="text-xl lg:text-2xl mb-4 font-bold text-center">
          Create Invoice
        </h2>

        {/* Ensure formData is passed to FormTemplate */}
        <FormTemplate fields={stepFields[activeStep]} formData={formData || {}} onChange={handleChange} />

        <div className="mt-auto flex items-center justify-between pt-4">
          <span className="text-gray-600 font-semibold">
            Page {activeStep + 1} of {steps.length}
          </span>
          <div className="flex space-x-4">
            <button
              onClick={handleCancel}
              className="px-4 py-2 rounded-md border border-gray-400 transition-transform transform hover:scale-105 text-white bg-red-500 hover:bg-red-600"
            >
              Cancel
            </button>
            {activeStep > 0 && (
              <button
                onClick={handleBack}
                className="px-4 py-2 rounded-md border border-gray-400 transition-transform transform hover:scale-105 text-white bg-gray-300 hover:bg-blue-600"
              >
                Back
              </button>
            )}
            {activeStep === steps.length - 1 ? (
              <button
                onClick={handleFinish}
                className="px-4 py-2 rounded-md border border-gray-400 transition-transform transform hover:scale-105 text-white bg-blue-600"
              >
                Finish
              </button>
            ) : (
              <button
                onClick={handleNext}
                className="px-4 py-2 rounded-md border border-gray-400 transition-transform transform hover:scale-105 text-white bg-blue-600"
              >
                Next
              </button>
            )}
          </div>
        </div>
      </div>

      <div className="w-full lg:w-2/5 p-5 bg-white rounded-lg border border-gray-300 shadow-xl flex flex-col">
        <Stepper activeStep={activeStep} orientation="vertical" className="gap-3">
          {steps.map((label, index) => (
            <Step key={index}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </div>
    </div>
  );
};

export default InvoiceFormWizard;
